var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-container"},[_c('iframe',{attrs:{"src":_vm.resultUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }